<script>
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';

import BudgetAccount from './components/budget_account.vue';
import Budget from './components/budget.vue';
import BusinessOrganization from './components/business_organization.vue';
import ParticipatingProducts from './components/participating_products.vue';
import RewardRules from './components/reward_rules.vue';

formCreate.component('BudgetAccount', BudgetAccount);
formCreate.component('Budget', Budget);
formCreate.component('BusinessOrganization', BusinessOrganization);
formCreate.component('ParticipatingProducts', ParticipatingProducts);
formCreate.component('RewardRules', RewardRules);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      row: null,
      buttonText: {
        submit: '提交',
        close: '关闭',
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          },
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          },
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          },
        }],
      },
      buttons: {
        submit:
          this.formConfig.code !== 'view',
        close: true,
        loading: false,
      },
      scanTypeList: [],
      awardWayList: [],
      wayTypeList: [],
    };
  },
  async created() {
    await this.getTypeList();
    console.log(this.formConfig);
    const rule = await this.getBeforFormRule(
      'consumer_consumerScan_form',
      'CRM20220914000000003',
    );
    rule.forEach((item) => {
      const v = item;
      if (v.field === 'datePicker') {
        v.props = {
          ...v.props,
          type: 'datetimerange',
          pickerOptions: this.pickerOptions,
          rangeSeparator: '至',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期',
          unlinkPanels: true,
          align: 'right',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: ['00:00:00', '23:59:59'],
        };
      } else if (v.field === 'budgetSubjectName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'budget_subjects_list_1',
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
        v.on = {
          ...v.on,
          change: (e) => {
            this.setValue({
              budgetSubjectCode: e ? e[0].budgetSubjectsCode : '',
              budgetSubjectName: e ? e[0].budgetSubjectsName : '',
              budgetCode: '',
              budgetName: '',
              feeOrgCode: '',
              orgName: '',
              orgReqVos: [],
            });
          },
        };
      } else if (v.field === 'budgetName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'budget_list_1',
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
        v.on = {
          ...v.on,
          change: (e) => {
            this.setValue({
              budgetCode: e ? e[0].feeBudgetCode : '',
              budgetName: e ? e[0].feeBudgetTypeName : '',
              feeOrgCode: e ? e[0].orgCode : '',
              productLevelCode: e ? e[0].productLevelCode : '',
              orgName: '',
              orgReqVos: [],
            });
          },
        };
      } else if (v.field === 'orgName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'business_organization_list_1',
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
          autosize: { minRows: 1, maxRows: 6 },
        };
        v.on = {
          ...v.on,
          change: (e) => {
            let orgNames = '';
            const orgReqVos = [];
            e.forEach((m) => {
              const obj = m;
              orgNames += `${obj.orgName},`;
              orgReqVos.push({
                orgName: obj.orgName,
                orgCode: obj.orgCode,
              });
            });
            this.setValue({
              orgName: orgNames || '',
              orgReqVos: orgReqVos || [],
            });
          },
        };
      }
      if (v.field === 'activityDescribe') {
        v.props = {
          ...v.props,
          autosize: { minRows: 5 },
        };
      }
      if (v.field === 'productReqVos') {
        v.props = {
          ...v.props,
          getValue: (field) => this.getFieldValue(field),
          setValue: (value) => this.setValue(value),
          hiddenFields: (hidden, fields) => this.hiddenFields(hidden, fields),
        };
        v.on = {
          ...v.on,
          change: (val) => {
            this.setValue({ productReqVos: val });
          },
        };
      }
      if (v.field === 'wayRule') {
        v.props = {
          ...v.props,
          parentCode: 'CRM20220914000000003',
          functionCode: 'reward_rules_list',
          getValue: (field) => this.getFieldValue(field),
          setValue: (value) => this.setValue(value),
          hiddenFields: (hidden, fields) => this.hiddenFields(hidden, fields),
        };
        v.value = [];
      }
      if (this.formConfig.code === 'view') {
        v.props = {
          ...v.props,
          disabled: true,
        };
        this.buttons.submit = false;
      }
    });
    this.rule = rule;
    this.reload(this.rule);
    if (
      this.formConfig.code === 'edit'
      || this.formConfig.code === 'view'
    ) {
      this.getDetail();
    }
  },
  methods: {
    // 获取详情
    async getDetail() {
      const res = await request.post(
        '/cps-mobile/consumerscanactivitymain/query',
        { activityCode: this.formConfig.row.activityCode },
      );
      if (res.success) {
        const { result } = res;
        const param = {
          feeBudgetCode: result.budgetCode,
        };
        request.post('/tpm/tpmFeeBudgetController/list', param).then((res1) => {
          if (res1.success) {
            result.productLevelCode = res1.result.data[0].productLevelCode;
            result.wayRule = [{
              scanType: result.scanType,
              scanTypeName: this.scanTypeList.find((k) => k.dictCode === result.scanType).dictValue || '',
              awardWay: result.awardWay,
              awardWayName: this.awardWayList.find((k) => k.dictCode === result.awardWay).dictValue || '',
              wayType: result.wayType,
              wayTypeName: this.wayTypeList.find((k) => k.dictCode === result.wayType).dictValue || '',
              wayMoney: Number(result.wayMoney),
              distanceAstrict: Number(result.distanceAstrict),
            }];
            result.productReqVos = (result.productReqVos || []).map((m) => {
              const obj = m;
              obj.ext3 = obj.unit;
              obj.spec = obj.specification;
              obj.productType = obj.type;
              return obj;
            });
            let orgNames = '';
            (result.orgReqVos || []).forEach((m) => {
              const obj = m;
              orgNames += `${obj.orgName},`;
            });
            result.orgName = orgNames;
            result.datePicker = [result.activityStartTime, result.activityEndTime];
            this.setValue(result);
            this.row = res.result;
          }
        });
      }
    },
    // 客户类型和终端类型
    getTypeList() {
      const param = ['scan_type', 'award_way', 'wayType'];
      request.post('/mdm/mdmdictdata/batchDictSelect', param).then((res) => {
        if (res.success) {
          this.scanTypeList = res.result.scan_type || [];
          this.awardWayList = res.result.award_way || [];
          this.wayTypeList = res.result.wayType || [];
        }
      });
    },
    // 提交
    submit(e) {
      console.log(e);
      const formData = this.getFormData();
      console.log('formData', formData);
      const { wayRule } = formData;
      if (!formData) return false;
      let params = formData;
      if (!params.productReqVos || params.productReqVos.length === 0) {
        this.$message.error('请选择参与产品！');
        return;
      }
      if (!params.wayRule || params.wayRule.length === 0) {
        this.$message.error('请选择奖励规则！');
        return;
      }
      params.activityStartTime = formData.datePicker && formData.datePicker.length > 0
        ? formData.datePicker[0]
        : null;
      params.activityEndTime = formData.datePicker && formData.datePicker.length > 0
        ? formData.datePicker[1]
        : null;
      params.productReqVos = (params.productReqVos || []).map((m) => {
        const obj = m;
        obj.id = '';
        obj.unit = obj.ext3;
        obj.specification = obj.spec;
        obj.type = obj.productType;
        return obj;
      });
      params.scanType = wayRule[0].scanType || '';
      params.awardWay = wayRule[0].awardWay || '';
      params.wayType = wayRule[0].wayType || '';
      params.wayMoney = wayRule[0].wayMoney || 0;
      params.distanceAstrict = wayRule[0].distanceAstrict || 0;
      delete params.datePicker;
      delete params.wayRule;
      delete params.feeOrgCode;
      delete params.orgName;
      delete params.title1;
      delete params.title2;
      delete params.title3;
      console.log(params);
      let url = '/cps-mobile/consumerscanactivitymain/save';

      if (this.formConfig.code === 'edit') {
        url = '/cps-mobile/consumerscanactivitymain/update';
        params = Object.assign(this.row, params);
      }
      request.post(url, params).then((res) => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });

          this.$emit('onClose');
          this.$emit('onGetList');
        }
      });
    },
  },
};
</script>
